exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cz .weui-msg__icon-area {\n  visibility: hidden;\n  margin-bottom: 0.2rem;\n}\n.cz .weui-msg__title {\n  font-size: 1.1rem;\n  color: white;\n}", ""]);

// exports
